<template>
    <div>
        <rkm-form
            ref="Form"
        >
            <rkm-row class="flex-nowrap">

                <rkm-col class="flex-grow-1">
                    <rkm-form-select
                        :options="laboratorios"
                        label="Laboratório / Unidade urgência/emergência"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="unidade.relacionadaUnidadeId"
                        :validations="validations.unidade"
                        value-field="unidadeId"
                    />
                </rkm-col>

                <rkm-col class="flex-grow-1">
                    <rkm-form-select
                        label="Local de atendimento"
                        :options="infraestruturas"
                        textField="nome"
                        v-model="unidade.relacionadaInfraestruturaId"
                        :validations="validations.infraestrutura"
                        valueField="id"
                        show-default-option
                    />
                </rkm-col>

                <rkm-col class="flex-grow-0">
                    <rkm-button
                        :label="false"
                        color="primary"
                        @click.stop="$refs.Form.validate(add)"
                    >
                        Incluir
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-table
            :fields="fields"
            :items="faturamentoRelacionado"
            ref="Table"
            sort-by="unidadeRelacionada"
            hide-filters
        >
            <template v-slot:cell(unidadeRelacionada)="row">
                <span>{{ row.item.unidadeRelacionada }}</span>
            </template>

            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    color="danger"
                    title="Excluir"
                    small
                    @click.stop="handleDestroy(item)"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>

<script>

// Mixins.
import { object } from '@/mixins'

// Enums.
import tipoUnidade from '@/enums/exame-laboratorial/tipoUnidade'

export default {
    mixins: [ object ],
    computed: {
        validations() {

            return {
                unidade: { required: true },
                infraestrutura: { required: true },
            }
        },
        fields() {

            const fields = [
                {
                    key: 'unidadeRelacionada',
                    label: 'Laboratório / Unidade urgência/emergência"',
                    sortable: true
                },
                {
                    key: 'infraestruturaNome',
                    label: 'Local de atendimento',
                    sortable: true
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min',
                },
            ]

            return fields
        },
        laboratorios() {
            const unidades = [];

            this.data.model.unidades.forEach(unidade => {

                const unidadeSolicitante = this.data.model.unidadesSolicitantes.find(solicitante => solicitante.infraestruturaId === unidade.infraestruturaId
                    && solicitante.urgencia)

                if (!unidade.laboratorio && !unidadeSolicitante) return;

                const infraestruturaId = unidade.infraestruturaId;

                const cadastrada =
                    (!this.item && this.data.model.laboratoriosFaturamento.some(principal => principal.infraestruturaId === infraestruturaId))
                        || this.infraestruturaId == infraestruturaId
                        || this.data.form.laboratoriosFaturamento.some(principal => principal.infraestruturaId === infraestruturaId)
                        || this.data.model.laboratoriosFaturamento.some(item =>
                            item.faturamentoRelacionado.some(relacionada =>
                                relacionada.relacionadaInfraestruturaId === infraestruturaId
                            )
                        );

                if (!cadastrada) {

                    let unidadeInserida = unidades.find(u => u.unidadeId === unidade.unidadeId);

                    if (unidadeInserida) {
                        unidadeInserida.infraestruturas.push({
                            id: infraestruturaId,
                            nome: unidade.infraestruturaNome,
                            principal: unidade.infraestruturaPrincipal,
                        });
                    } else {
                        unidades.push({
                            unidadeId: unidade.unidadeId,
                            nomeFantasia: unidade.nomeFantasia,
                            infraestruturas: [{
                                id: infraestruturaId,
                                nome: unidade.infraestruturaNome,
                                principal: unidade.infraestruturaPrincipal,
                            }]
                        });
                    }
                }
            });

            return unidades.length
                ? unidades.sort((a, b) => a.nomeFantasia.localeCompare(b.nomeFantasia))
                : unidades;
        },
        infraestruturas() {

            if (this.unidade.relacionadaUnidadeId) {

                let infraestruturaPrincipal = this.data.form.unidades.find(u => u.id === this.unidade.relacionadaUnidadeId).infraestruturas

                this.getPrincipal(infraestruturaPrincipal)

                return infraestruturaPrincipal.length > 0
                    ? infraestruturaPrincipal.sort((a,b) => (a.nome > b.nome) ? 1 : ((b.nome > a.nome) ? -1 : 0))
                    : infraestruturaPrincipal
            } else {

                this.setRelacionadaInfraestrutura()
            }

            return []
        },
    },
    methods: {
        add() {

            this.validate()
                .then(valid => {

                    if (!valid) return

                    const unidade = this.clone(this.unidade)

                    unidade.unidadeRelacionada = this.laboratorios
                        .find(s => s.unidadeId === unidade.relacionadaUnidadeId).nomeFantasia

                    unidade.infraestruturaNome = this.infraestruturas
                        .find(s => s.id === unidade.relacionadaInfraestruturaId).nome

                    unidade.infraestruturaId = this.infraestruturaId
                    unidade.unidadeId = this.unidadeId

                    this.faturamentoRelacionado.push(unidade)

                    this.resetForm()
                })
        },
        getPrincipal(infraestruturaPrincipal) {

            this.unidade.relacionadaInfraestruturaId = infraestruturaPrincipal.find(u => u.principal === true).id
        },
        async validate() {

            const hasSetor = this.faturamentoRelacionado
                .find(cc => cc.relacionadaUnidadeId === this.unidade.relacionadaUnidadeId
                    && cc.relacionadaInfraestruturaId === this.unidade.relacionadaInfraestruturaId)

            if (hasSetor) {

                const unidadeSolicitante = this.laboratorios
                    .find(s => s.unidadeId === this.unidade.relacionadaUnidadeId).nomeFantasia

                const infraestruturaNome = this.infraestruturas
                    .find(s => s.id === this.unidade.relacionadaInfraestruturaId).nome

                this.showValidationNotification(`A unidade solicitante <strong>${ unidadeSolicitante }</strong> e o
                    local de atendimento <strong>${ infraestruturaNome }</strong> já estão cadastrados.`)

                return false
            }

            return true
        },
        resetForm() {

            this.unidade.relacionadaUnidadeId = null
            this.unidade.unidadeRelacionada = ''
            this.unidade.infraestruturaNome = ''
            this.unidade.relacionadaInfraestruturaId = null

            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
        setRelacionadaInfraestrutura(){

            this.unidade.relacionadaInfraestruturaId = null
        },
        handleDestroy(item) {

            const destroy = async () => {

                const objIndex = this.data.form.laboratoriosFaturamento.findIndex(unidade => unidade.infraestruturaId
                    == item.relacionadaInfraestruturaId)

                if (objIndex >= 0) {
                    this.data.form.laboratoriosFaturamento.splice(objIndex, 1)
                }

                const index = this.faturamentoRelacionado.findIndex(unidade => unidade.relacionadaInfraestruturaId
                    == item.relacionadaInfraestruturaId)

                if (index >= 0) {
                    this.faturamentoRelacionado.splice(index, 1)
                }
            }

            this.showDeleteConfirmation(`Deseja realmente excluir o laboratório
                <strong>${ item.unidadeRelacionada }</strong> e o  local de atendimento
                <strong>${ item.infraestruturaNome }</strong>?`,
                destroy)
        },
    },
    props: {
        data: { type: Object, required: true },
        faturamentoRelacionado: { type: Array, required: true },
        unidadeId: { type: Number, required: true },
        infraestruturaId: { type: Number, required: true },
        unidadeDisabled: { type: Boolean, default: false },
    },
    data: () => ({
        form: {
            unidades: {}
        },
        model: {},
        enums: {
            tipoUnidade
        },
        unidade: {
            unidadeId: null,
            infraestruturaId: null,
            relacionadaUnidadeId: null,
            relacionadaInfraestruturaId: null,
            unidadeRelacionada: '',
            infraestruturaNome: '',
        },
    }),
}
</script>